module.exports = __webpack_public_path__ + "static/media/message-icon-round.49f306ae.svg";